import React from 'react'
import { Container } from 'reactstrap';

import LoginForm from './login-form';
import { WelcomeMessage } from './WelcomeMessage';

const LoginPage = () => {
  return (
    <Container fluid="xl" className='minvh-100 px-0 px-md-3'>
      <div className="d-md-flex align-items-md-stretch justify-content-md-center minvh-100">
        <WelcomeMessage displayClass={'d-none d-md-block'}/>
        <div className="col-login p-md-4 align-self-center">
          <div className='bg-white p-4 col-login-form d-flex flex-column h-100'>
            <LoginForm />
          </div>
        </div>
      </div>
    </Container>
  );
}

export default LoginPage;